(function() {
    'use strict';
    angular
        .module('editorApp')
        .factory('MessageService', MessageService);

    MessageService.$inject = ['$uibModal', '$translate'];

    function MessageService($uibModal, $translate) {
        var service = {
            confirm: confirm,
            minConfirm: minConfirm,
            successConfirm: successConfirm,
            comment:comment,
            loading:loading,
            error:error,
            notice:notice,
            info:info,
            success:success,
            notify:notify,
            hint:hint


        };

        var settings = {
            title: 'The notice title.', // The notice's title.
            title_escape: false, // Whether to escape the content of the title. (Not allow HTML.)
            // text: 'The notice text.', // The notice's text.
            text_escape: false, // Whether to escape the content of the text. (Not allow HTML.)
            styling: "bootstrap3", // What styling classes to use. (Can be either jqueryui or bootstrap or bootstrap3.)
            // addclass: "", // Additional classes to be added to the notice. (For custom styling.)
            // cornerclass: "", // Class to be added to the notice for corner styling.
            // nonblock: false, // Create a non-blocking notice. It lets the user click elements underneath it.
            // nonblock_opacity: .2, // The opacity of the notice (if it's non-blocking) when the mouse is over it.
            history: false, // Display a pull down menu to redisplay previous notices, and place the notice in the history.
            // width: "300px", // Width of the notice.
            // min_height: "16px", // Minimum height of the notice. It will expand to fit content.
            type: "notice", // Type of the notice. "notice", "info", "success", or "error".
            icon: true, // Set icon to true to use the default icon for the selected style/type, false for no icon, or a string for your own icon class.
            // animation: "fade", // The animation to use when displaying and hiding the notice. "none", "show", "fade", and "slide" are built in to jQuery. Others require jQuery UI. Use an object with effect_in and effect_out to use different effects.
            // animate_speed: "slow", // Speed at which the notice animates in and out. "slow", "def" or "normal", "fast" or number of milliseconds.
            // opacity: 1, // Opacity of the notice.
            // shadow: true, // Display a drop shadow.
            // closer: true, // Provide a button for the user to manually close the notice.
            // closer_hover: true, // Only show the closer button on hover.
            // sticker: true, // Provide a button for the user to manually stick the notice.
            // sticker_hover: true, // Only show the sticker button on hover.
            // hide: true, // After a delay, remove the notice.
            delay: 5000 // Delay in milliseconds before the notice is removed.
                // mouse_reset: true, // Reset the hide timer if the mouse moves over the notice.
                // remove: true, // Remove the notice's elements from the DOM after it is removed.
                // insert_brs: true, // Change new lines to br tags.
                // stack: {"dir1": "down", "dir2": "left", "push": "bottom", "spacing1": 25, "spacing2": 25}
        };
        var current;

        function hint(content,time) {
            var _time = time || 2000;
            var _html = '<div class="three-modal2" id="c-modal1">\n' +
                '    <div class="three-modal2-body">\n' +
                '        <div>'+content+'</div>\n' +
                '    </div>\n' +
                '</div>';
            $("body").append(_html);
            setTimeout(function () {
                $("#c-modal1").remove();
            },_time)
        };
        function notice(content) {
            var hash = angular.copy(settings);
            hash.type = 'notice';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function info(content) {
            var hash = angular.copy(settings);
            hash.type = 'info';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function success(content) {
            var hash = angular.copy(settings);
            hash.type = 'success';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function error(content) {
            var hash = angular.copy(settings);
            hash.type = 'error';
            hash.title = content;
            return this.notify(hash);
        };

        function notify(hash) {
            if (current) {
                current.remove();
            }
            current = new PNotify(hash);
            return current;

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + hash.title + '</h3>' + //
                    '</div>' + //
                    '</div>',
            });
        };

        function loading() {
            return $uibModal.open({
                template: '<i class="fa fa-5x fa-spinner fa-spin fa-white"></i>',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'loading-window'
            });
        };

        function confirm(obj,confirmCallback, cancelCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {
                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };
                    $scope.cancel = function(value) {
                        $uibModalInstance.dismiss({cancel: true, value: value});
                    };
                    $scope.htmlClick = function() {
                        $uibModalInstance.close('htmlClick');
                    };
                }
            ];
            var htmlPart = obj.html ? ('<span class="themeColor-pointer" ng-click="htmlClick()">'+obj.html+'</span>') : '';
            var backdropConfig = obj.html ? 'static' : true;
            if(!!translate){
                var modalInstance = $uibModal.open({
                    template: '<div class="confirm-dialog">' + //
                        '<div class="confirm-dialog-header">' + //
                        '<div class="confirm-dialog-title">'+obj.title+'</div>' + //
                        '<span class="iconfont iconcloseicon1" ng-click="cancel(true)"></span>' + //
                        '</div>' + //
                        '<div class="confirm-dialog-content">'+obj.msg+ htmlPart +
                        '</div>'+
                        '<div class="confirm-dialog-footer">'+
                        (obj.cancel ? '<button class="confirm-dialog-footer-cancel" translate="entity.action.cancel" ng-click="cancel(false)">'+obj.cancel+'</button>' : '') +
                        '<button class="confirm-dialog-footer-delete" ng-click="ok()">'+obj.confirm+'</button>'+
                        '</div>'+
                        '</div>'+
                        '<style>.modal-content{width: 528px;}</style>',
                    controller: ModalInstanceCtrl,
                    backdrop: backdropConfig
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="confirm-dialog">' + //
                    '<div class="confirm-dialog-header">' + //
                    '<div class="confirm-dialog-title">'+obj.title+'</div>' + //
                    '<span class="iconfont iconcloseicon1" ng-click="cancel(true)"></span>' + //
                    '</div>' + //
                    '<div class="confirm-dialog-content">'+obj.msg+ htmlPart +
                    '</div>'+
                    '<div class="confirm-dialog-footer">'+
                    (obj.cancel ? '<button class="confirm-dialog-footer-cancel" ng-click="cancel(false)">'+obj.cancel+'</button>' : '') +
                    '<button class="confirm-dialog-footer-delete" ng-click="ok()">'+obj.confirm+'</button>'+
                    '</div>'+
                    '</div>'+
                    '<style>.modal-content{width: 528px;}</style>',
                    controller: ModalInstanceCtrl,
                    backdrop: backdropConfig
                });
            }


            modalInstance.result.then(function(res) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(res);
                }
            }, function(res) {
                if (res && res.cancel) {
                    if (typeof cancelCallback == 'function') {
                        cancelCallback(res.value);
                    }
                }
            });

        };
        function minConfirm(obj,confirmCallback, cancelCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function(value) {
                        $uibModalInstance.dismiss({cancel: true, value: value});
                    };
                }
            ];
            var modalInstance = $uibModal.open({
                template: '<div class="confirm-dialog" style="padding: 0;">' + //
                    (obj.hide ? '<span class="iconfont iconguanbi11" ng-click="cancel(true)" style="position: absolute;left: 50%;bottom: -40px;color: #fff;margin-left: -12px;font-size: 24px;"></span>' : '') +
                    '<div class="confirm-dialog-content" style="padding: 24px;">'+obj.msg+
                    '</div>'+
                    '<div class="confirm-dialog-footer" style=" justify-content: center;border-top: 1px solid #ddd;">'+
                    (obj.cancel ? '<button class="confirm-dialog-footer-cancel" ng-click="cancel(false)" style=" width: 100%;border-radius: 0;background: none;color: #333;border-right: 1px solid #ddd;">'+obj.cancel+'</button>' : '') +
                    '<button class="confirm-dialog-footer-delete" ng-click="ok()" style=" width: 100%;margin: 0;border-radius: 0;background: none;color: var(--webMainButtonBackColor);">'+obj.confirm+'</button>'+
                    '</div>'+
                    '</div>'+
                    '<style>.modal-content{width: 528px !important;overflow: unset !important;}</style>',
                controller: ModalInstanceCtrl
            });


            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function(res) {
                if (res && res.cancel) {
                    if (typeof cancelCallback == 'function') {
                        cancelCallback(res.value);
                    }
                }
            });

        };

        function successConfirm(msg, confirmCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                }
            ];

            if(!!translate){
                 var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()"><label translate='+msg+'></label></h3>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()">' + msg + '</h3>',
                    controller: ModalInstanceCtrl
                });
            }



            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            });
        };

        function comment(msg, confirmCallback, cancelCallback, commentMust, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance', '$timeout',
                function($scope, $uibModalInstance, $timeout) {
                    $scope.ok = function(comment) {
                        if (commentMust && !comment) {
                            // return self.error('评论必填');
                            $scope.error = true;
                            return;
                        }
                        $scope.error = false;
                        $uibModalInstance.close(comment);
                    };
                    if (commentMust) {
                        $scope.placeholderMsg = $translate.instant("hint.commentRequired");
                    } else {
                        $scope.placeholderMsg = $translate.instant("hint.commentOptional");
                    }

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $timeout(function() {
                        $scope.$apply();
                    });
                }
            ];

            if(!!translate){
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3><label translate='+msg+'></label></h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error" translate="hint.required">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()" translate="button.cancel">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)" translate="button.confirm">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3>' + msg + '</h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error" translate="hint.required">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()" translate="button.cancel">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)" translate="button.confirm">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }

            modalInstance.result.then(function(comment) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(comment);
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });
        };
        return service;
    }

})();
